import React, { useEffect, useState } from "react";
import CustomEditCard from "../../../../common/components/CustomEditCard/CustomEditCard";
import { Box, Typography } from "@mui/material";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { fonts, themes } from "../../../../common/themes/themes";
import AboutMeModalController from "../../../../common/Modals/PersonalDetails/AboutMeModal/AboutMeModalController";

interface propsType {
  aboutMeData: aboutMeType;
  isCardUpdate: (data: boolean) => void;
  hr_view?: boolean;
  trans?: any;
}
const EmergencyContactPresenter: React.FC<propsType> = ({
  aboutMeData,
  isCardUpdate,
  hr_view,
  trans,
}) => {
  const callBackCardUpdate = (cardUpdate: boolean) => {
    isCardUpdate(cardUpdate);
  };
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <CustomEditCard
        card_title={trans("About Me")}
        card_height="204px"
        onClick={() => setOpenModal(true)}
        showEditButton={true}
      >
        <Box style={{ marginBottom: "24px" }} />
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontSize: fonts.title,
            color: themes.tileValue_black,
          }}
        >
          {aboutMeData.about_me}
        </Typography>
      </CustomEditCard>

      {/* About Me Detail Modal */}

      {openModal && (
        <AboutMeModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          isCardUpdate={callBackCardUpdate}
          trans={trans}
        />
      )}
    </div>
  );
};

export default EmergencyContactPresenter;
